<script setup>
    import { ref, computed, onMounted } from 'vue';
    import { storeToRefs } from 'pinia';
    import { useHomeStore } from '../stores/home';

    const props = defineProps({
        title: {
            type: String,
            default: 'Hasta 18 meses sin intereses',
        },
        buttonText: {
            type: String,
            default: 'Mas formas de pago',
        },
        banks: {
            type: Array,
            default: () => [],
        },
        userLocation: {
            type: Object,
            default: {}
        },
        enemoUrl: {
            type: String,
            default: ""
        }
    });


    const homeStore = useHomeStore();

    const {
        getTopPaymentBanks,
        getResponsePaymentsMaxMSI,
        getResponsePaymentsMSI,
        getResponsePaymentsLoading,
        getResponsePaymentsDepositBanks
    } = storeToRefs(homeStore);


    const config = ref(window.__pt.settings.site);
    const culture = ref(window.__pt.settings.site);

    const emit = defineEmits(['action']);

    const handleCardClick = () => {
        emit('action');
    };

    const showModalPayments = () => {
        const modalElement = document.getElementById('modal-payform');
        if (!modalElement) return;

        window.$(modalElement).modal('show');
    };

    onMounted(() => {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                        img.removeAttribute('data-src');
                    }
                    obs.unobserve(img);
                }
            });
        }, { rootMargin: '50px' });

        document.querySelectorAll('.promo__list img[data-src]').forEach(img => {
            observer.observe(img);
        });
    });

</script>

<template>
    <aside class="promo"
           aria-labelledby="promo-title"
           @click="showModalPayments">
        <div class="promo__header">
            <h2 v-if="(config.siteName || '').toLowerCase()  === 'pricetravel' && userLocation.country != 'US'" id="promo-title"
                class="promo__title font-main">
                {{ __('payment.modaltb_payment_until') }} {{ getResponsePaymentsMaxMSI }}
            </h2>

            <h2 v-else-if="(config.siteName || '').toLowerCase() === 'tiquetesbaratos'" id="promo-title"
                class="promo__title font-main">
                {{ __('payment.pay_best_optionstb') }}
            </h2>

            <h2 v-else id="promo-title"
                class="promo__title font-main">
                {{ __('payment.pay_best_options') }}
            </h2>

            <button v-if="userLocation.country != 'US'" class="promo__btn promo__btn--desktop btnTertiary btnTertiary--md"
                    type="button">

                        {{
                             config.siteName == 'pricetravel'
                                    ? __('payment.get_our_payment_methods')
                                    : __('payment.get_our_payment_methodstb')
                        }}

                <span class="promo__icon icons-angle-right font-20" aria-hidden="true"></span>
            </button>
        </div>

        <div class="promo__box">
            <ul 
                class="promo__list">
                <li v-for="bank in banks" v-if="config.siteName != 'tiquetesbaratos'"
                    :key="bank.name"
                    class="promo__item">
                    <div v-if="bank.icon || bank.name"
                         role="img"
                         :aria-label="bank.name"
                         class="promo__icon icon-bank-brand"
                         :class="bank.icon"
                         :style="{
                              width: bank.width ? `${bank.width}px` : 'auto',
                              height: bank.height ? `${bank.height}px` : 'auto',
                            }"></div>
                </li>

                <li class="promo__item" v-if="config.siteName != 'tiquetesbaratos' && userLocation.country == 'MX'">
                    <img data-src="/assets/img/logos_banks/logo-paypal.svg" aria-label="paypal" alt="paypal" width="78" height="26" />
                </li>

                <li class="promo__item" v-if="config.siteName != 'tiquetesbaratos' && userLocation.country == 'MX'">
                    <img data-src="/assets/img/logos_banks/logo-applepay.svg" alt="apple pay" width="39" height="16" />
                </li>

                <li class="promo__item" v-if="config.siteName === 'tiquetesbaratos' || userLocation.country != 'MX'">
                    <img data-src="https://static.cdnpth.com/images/bancos/logo-visa.svg" alt="visa card" width="50" height="16" />
                </li>

                <li class="promo__item" v-if="config.siteName === 'tiquetesbaratos' || userLocation.country != 'MX'">
                    <img data-src="https://static.cdnpth.com/images/bancos/logo-amex.svg" alt="american express" width="26" height="26" />
                </li>

                <li class="promo__item" v-if="config.siteName === 'tiquetesbaratos' || userLocation.country != 'MX'">
                    <img data-src="https://static.cdnpth.com/images/bancos/logo-mastercard.svg" alt="mastercard" width="34" height="26" />
                </li>

                <li class="promo__item" v-if="config.siteName === 'tiquetesbaratos' || userLocation.country === 'US'">
                    <img data-src="https://static.cdnpth.com/images/bancos/logo-dinersclub.svg" alt="dinersclub" width="70" height="20" />
                </li>


                <li class="promo__item" v-if="config.siteName != 'tiquetesbaratos' && userLocation.country === 'US'">
                    <img data-src="/assets/img/logos_banks/logo-jcb.svg" aria-label="Japan Credit" alt="Japan Credit Bureau" width="34" height="26" />
                </li>

                <li class="promo__item" v-if="config.siteName != 'tiquetesbaratos' && userLocation.country === 'US'">
                    <img data-src="/assets/img/logos_banks/logo-discover.svg" aria-label="Discover" alt="Discover" width="78" height="14" />
                </li>

                <li class="promo__item" v-if="config.siteName != 'tiquetesbaratos' && userLocation.country === 'US'">
                    <img data-src="https://static.cdnpth.com/images/bancos/logo-maestro.svg" alt="maestro" width="34" height="26" />
                </li>

                <li class="promo__item" v-if="config.siteName != 'tiquetesbaratos' && userLocation.country === 'US'">
                    <img data-src="/assets/img/logos_banks/logo-klarna.svg" aria-label="klarna" alt="klarna" width="49" height="20" />
                </li>

                <li class="promo__item" v-if="config.siteName != 'tiquetesbaratos' && userLocation.country === 'US'">
                    <img data-src="/assets/img/logos_banks/logo-applepay.svg" alt="apple pay" width="39" height="16" />
                </li>

                <li class="promo__item" v-if="config.siteName != 'tiquetesbaratos' && userLocation.country === 'US'">
                    <img data-src="/assets/img/logos_banks/logo-paypal.svg" aria-label="paypal" alt="paypal" width="78" height="26" />
                </li>


                <li class="promo__item" v-if="config.siteName === 'tiquetesbaratos' || userLocation.country === 'CO'">
                    <img data-src="https://static.cdnpth.com/images/bancos/logo-pse.svg" alt="PSE" width="26" height="26" />
                </li>

                <li class="promo__item" v-if="config.siteName === 'tiquetesbaratos' || userLocation.country === 'CO'">
                    <img data-src="https://static.cdnpth.com/images/bancos/logo-bancolombia.png" aria-label="Bancolombia" alt="Bancolombia" width="83" height="26" />
                </li>

                <li class="promo__item" v-if="config.siteName === 'tiquetesbaratos' || userLocation.country === 'CO'">
                    <img data-src="https://static.cdnpth.com/images/bancos/logo-efecty.svg" alt="efecty" width="26" height="26" />
                </li>

                <li class="promo__item" v-if="config.siteName === 'tiquetesbaratos' || userLocation.country === 'CO'">
                    <img data-src="https://static.cdnpth.com/images/bancos/logo-daviplata.svg" alt="daviplata" width="70" height="26" />
                </li>

                <li class="promo__item" v-if="config.siteName === 'tiquetesbaratos' || userLocation.country === 'CO'">
                    <img data-src="https://static.cdnpth.com/images/bancos/logo-nequi.svg" alt="nequi" width="70" height="26" />
                </li>
            </ul>

            <button class="promo__btn promo__btn--mobile btnTertiary btnTertiary--md"
                    type="button">
                {{ buttonText }}
                <span class="promo__icon icons-angle-right font-20"
                      aria-hidden="true"></span>
            </button>
        </div>
    </aside>
</template>
<style scoped lang="scss">
    .promo {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--space-20);
        background-color: var(--bg-base);
        padding: var(--space-20) var(--space-16) var(--space-4);
        border: 1px solid var(--border-subtle);
        border-radius: var(--space-16);
        text-align: center;
        cursor: pointer;
    }

    .promo__icon {
        display: flex;
    }

    .promo__header {
        height: fit-content;
    }

    .promo__title {
        color: var(--text-main);
        font: var(--title-xs);
        margin-bottom: 0px;
        text-wrap: nowrap;
    }

    .promo__box {
        display: flex;
        flex-direction: column;
        gap: var(--space-4);
    }

    .promo__list {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: var(--space-20);
        justify-content: center;
        row-gap: var(--space-16);
        list-style: none;
        padding: 0px;
    }

    .promo__btn {
        display: flex;
        align-items: center;
        gap: var(--space-8);
    }

    .promo__btn--desktop {
        display: none;
    }

    @media (min-width: 768px) {
        .promo {
            flex-direction: row;
            padding: var(--space-28) 0px;
        }

        .promo__header {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: var(--space-8);
            padding: 0px calc(var(--space-4) * 12);
            border-right: 1px solid var(--border-subtle);
        }

        .promo__title {
            font: var(--title-sm);
        }

        .promo__box {
            gap: var(--space-20);
        }

        .promo__list {
            margin-bottom: 0px;
        }

        .promo__btn--desktop {
            display: flex;
        }

        .promo__btn--mobile {
            display: none;
        }
    }
</style>
